import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ApplicationModule } from './app/application.module';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;

import { LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';

navigator.serviceWorker.register('./files.zip.worker.js');

LicenseManager.setLicenseKey(ConfigService?.environment?.grid);
provideGlobalGridOptions({ theme: "legacy" });

if (ConfigService.environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(ApplicationModule);
